let React =            require("react");
let MasterPage =       require("./../../pages/generic/MasterPage.jsx");
let DataListPage =     require("./../../pages/generic/DataListPage.jsx");
let EmptyPackageCard = require("./../empty/EmptyPackageCard.jsx");
var Model3DCard =      require("./../cards/Model3DCard.jsx");

class Explore3DModels extends React.Component {

    constructor() {
        super()

       // this.state = { dataUrl: "", doingSearch: false, pageIndex: 1, error: {}};
    }
    
    componentDidMount() {
        document.title = `Explore/3DModels | library.io`;
        googleGA("send", "event", `explore/3DModels`, "pageview");
    }

    render() {
        //this config is necessary because search pages reuse the explorer view, by default the config is for explore pages, that config could be changed from the search page
        let {hasSearching = false} = this.props

        return  <DataListPage
                    {...this.props}
                    page="explore"
                    endpoint="/explore/3dmodels"
                    displayName={`3d Models`}
                    showNumElements={true}
                    urlName="3dmodels"
                    cssCardTag="package"
                    defaultLayout="grid"
                    hasSearching={hasSearching}
                    loginRequired={false}
                    canSwitchLayout
                    resetViewAfterNewUpload
                    uploadContentIsAboveTitle
                    EmptyCard={EmptyPackageCard}
                    CardType={Model3DCard}
                    hasSelectSort={true}
                    isPublicFacing={true}
                    hasGridLayoutSwitch={false}
                    showLoadingPlaceholder={false}
                />
    }
}

module.exports = Explore3DModels;
